module.exports = __webpack_public_path__ + "img/6.aabe8a1e.jpg";